import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

export interface ScreeningAlertsState {
  lastAlertUpdate: dayjs.Dayjs;
}

const initialState: ScreeningAlertsState = {
  lastAlertUpdate: dayjs(),
};

const screeningAlertsSlice = createSlice({
  name: 'screeningAlerts',
  initialState,
  reducers: {
    updateScreeningAlertSuccess: (state) => {
      state.lastAlertUpdate = dayjs();
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = screeningAlertsSlice;
// Extract and export each action creator by name
export const { updateScreeningAlertSuccess } = actions;
// Export the reducer, either as a default or named export
export default reducer;
